import { useCallback, useEffect } from "react";
import store from "../../store/store";
import Card from "../Card/Card";
import { gameActions } from "../Game/gameSlice";
import "./Table.scss";
import classNames from "classnames";
import React from "react";
import InputTooltip from "./InputTooltip";

export default function TableRevealed() {
  const gameState = store.getState().game;
  const userState = store.getState().user;
  const player = gameState.player;
  const players = gameState.players;

  const [commentCardId, setCommentCardId] = React.useState('');
  const [showComment, setShowComment] = React.useState(false);
  const keyPressed = useCallback((event) => {
    switch (event.key) {
      case 'Escape':
        setShowComment(false);
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", keyPressed, false);

    return () => {
      document.removeEventListener("keydown", keyPressed, false);
    };
  }, [keyPressed]);

  useEffect(() => {
    gameState.revealedCards?.forEach((it) => {
      const img = new Image();
      img.src = it.src;
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function vote(cardId: string) {
    if (player) {
      store.dispatch(gameActions.submitVote({
        gameId: gameState.gameId,
        playerId: player.data.playerId,
        voteCardId: cardId,
      }));
    }
  }

  function onCommentClick(cardId: string) {
    setShowComment(true);
    setCommentCardId(cardId);
  }

  function submitComment(comment: string) {

    if (!player) {
      return;
    }

    store.dispatch(gameActions.submitComment({
      gameId: gameState.gameId,
      playerId: player.data.playerId,
      cardId: commentCardId,
      comment: comment,
    }));

    setShowComment(false);
    setCommentCardId('');
  }

  const gameTableClassNames = classNames({
    'game-table': true,
    'game-table_revealed': true,
    [`game-table-${players.length}`]: true
  });

  return (
    <div className={gameTableClassNames}>
      {gameState.revealedCards.map((it) =>
        <Card
          card={{ cardId: it.cardId, src: it.src }}
          cards={gameState.revealedCards}
          key={it.cardId}
          onConfirm={() => { vote(it.cardId) }}
          onComment={() => onCommentClick(it.cardId)}
          isSelected={player?.data.isStoryteller && player?.matchCardId === it.cardId}
          isSelectable={true}
          isConfirm={(!player?.data.hasVoted && player?.matchCardId !== it.cardId) || (player?.voteCardId === it.cardId && player.data.hasVoted)}
          isConfirmable={!player?.data.hasVoted}
          confirmText={player?.data.hasVoted ? 'Selected' : 'Select'}
          confirmPrompt={userState.user.confirmActionEnabled ? `Are you sure you want to select this card?` : null}
        />)}
      {showComment && <InputTooltip onClose={() => setShowComment(false)} onSubmit={submitComment} comment={player?.cardComments?.[commentCardId]} />}
    </div>
  )
}